/**
 * *************************************
 *  SHADAPPS CONFIDENTIAL
 *  __________________
 *
 *  Created by Vittorio Tauro
 *
 *  2022 (c) ShadApps Srl
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of ShadApps Srl and its suppliers,
 *  if any. The intellectual and technical concepts contained
 *  herein are proprietary to ShadApps Srl.
 *  and its suppliers and may be covered by Italian, European and Foreign Patents,
 *  patents in process, and are protected by trade secret or copyright law.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from ShadApps Srl.
 * *************************************
 * */

// components
import LuggageIcon from '@mui/icons-material/Luggage';
import {
    ICONS,
    ICON_COMPONENTS,
    getIcon,
    getIconify,
} from '../../../lib/icons';
// ----------------------------------------------------------------------

const navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
        subheader: '',
        items: [{ title: 'Home', path: '/home', icon: getIconify(ICONS.home) }],
    },
    {
        subheader: 'GESTIONE VOLI',
        items: [
            { title: 'Voli', path: '/flights', icon: getIconify(ICONS.flight) },
            {
                title: 'Prenotazioni',
                path: '/bookings',
                icon: getIconify(ICONS.booking),
            },
            // { title: 'Voli acquistati', path: '/trips', icon: <LuggageIcon /> },
        ],
    },
    {
        subheader: 'CONFIGURAZIONE CLIENTI',
        items: [
            {
                title: 'passeggeri',
                path: '/passengers',
                icon: getIconify(ICONS.passenger),
            },
        ],
    },
    {
        subheader: 'CONFIGURAZIONE TRATTE',
        items: [
            {
                title: 'Pricing policy',
                path: '/pricingPolicies',
                icon: getIconify(ICONS.creditCard),
            },
            {
                title: 'aeroporto',
                path: '/airports',
                icon: getIconify(ICONS.airport),
            },
            {
                title: 'paesi',
                path: '/countries',
                icon: getIconify(ICONS.earth),
            },
            // { title: 'seats', path: '/seats', icon: getIconify(ICONS.seat) },
            // {
            //     title: 'bookings',
            //     path: '/bookings',
            //     icon: getIconify(ICONS.booking),
            // },
            // { title: 'Voli acquistati', path: '/trips', icon: <LuggageIcon /> },
        ],
    },
    {
        subheader: 'CONFIGURAZIONE AEREI',
        items: [
            {
                title: 'attributi aerei',
                path: '/attributes',
                icon: getIconify(ICONS.attribute),
            },
            {
                title: 'aerei',
                path: '/airplanetypes',
                icon: getIconify(ICONS.airplanetype),
            },
            {
                title: 'compagnia aerea',
                path: '/companies',
                icon: getIconify(ICONS.flight),
            },
        ],
    },

    {
        subheader: 'admin',
        items: [
            { title: 'Utenti', path: '/users', icon: getIconify(ICONS.user2) },
            // { title: 'files', path: '/uploads', icon: getIconify(ICONS.upload) },
            // { title: 'cms', path: '/cms', icon: getIconify(ICONS.cms) },
            {
                title: 'invite code',
                path: '/inviteCodes',
                icon: getIconify(ICONS.coupon),
            },
            { title: 'token', path: '/tokens', icon: getIconify(ICONS.cms) },
        ],
    },
];

export default navConfig;
